import { combineReducers } from 'redux';
import { DEFAULT_MAP_COORDINATES } from '@/types/distance.constants';

const initialUserState = null;
const initialFormDataState = {
  coordinates: DEFAULT_MAP_COORDINATES,
  spaceType: 'coworking',
  guests: [],
};
const initialLenguageState = { lang: null, isButton: false };
const initialCurrencyState = { currency: null, isButton: false };
const initialLocationState = { detected: false, data: null };
const initialCardListState = [];

const initialDoctorState = [];

const userReducer = (state = initialUserState, action) => {
  switch (action.type) {
    case 'SET_USER':
      return action.payload;
    case 'CLEAR_USER':
      return null;
    default:
      return state;
  }
};

const cardListReducer = (state = initialCardListState, action) => {
  switch (action.type) {
    case 'SET_CARD_LIST':
      return action.payload;
    case 'CLEAR_CARD_LIST':
      return null;
    default:
      return state;
  }
};

const searchFormDataReducer = (state = initialFormDataState, action) => {
  switch (action.type) {
    case 'SET_SEARCH_FORM_DATA':
      return action.payload;
    case 'CLEAR_SEARCH_FORM_DATA':
      return null;
    default:
      return state;
  }
};

const lenguageDataReducer = (state = initialLenguageState, action) => {
  switch (action.type) {
    case 'SET_LENGUAGE_DATA':
      return action.payload;
    case 'CLEAR_LENGUAGE_DATA':
      return null;
    default:
      return state;
  }
};

const currencyReducer = (state = initialCurrencyState, action) => {
  switch (action.type) {
    case 'SET_CURRENCY':
      return action.payload;
    case 'CLEAR_CURRENCY':
      return null;
    default:
      return state;
  }
};

const locationReducer = (state = initialLocationState, action) => {
  switch (action.type) {
    case 'SET_LOCATION':
      return {
        data: action.payload,
        detected: true,
      };
    case 'CLEAR_LOCATION':
      return { detected: false, data: null };
    default:
      return state;
  }
};

const doctorReducer = (state = initialDoctorState, action) => {
  switch (action.type) {
    case 'SET_DOCTORS':
      return action.payload;
    case 'CLEAR_DOCTORS':
      return [];
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  user: userReducer,
  searchFormData: searchFormDataReducer,
  lenguage: lenguageDataReducer,
  location: locationReducer,
  currency: currencyReducer,
  userCardList: cardListReducer,
  doctors: doctorReducer,
});

export default rootReducer;
